import { makeApiRequest } from '../../utils/make-api-request';

export async function descargarCaratula(folio: string): Promise<Blob> {
  const response = await makeApiRequest({ endpoint: `/compras/${folio}/descargar?q=${Date.now()}` });
  if (!response.ok) {
    throw new Error(`Error al descargar la carátula: ${response.statusText}`);
  }
  return await response.blob();
}
